<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="historical_threats" name="historical_threats" rules="required" v-slot="{ errors }">
              <small class="label">13.1 How do you keep informed of historical and developing threats to the supply chain which may present a risk to adulteration or substitution of raw materials?</small>
              <vs-input type="text" name="historical_threats" class="w-full" v-model="form.historical_threats" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_document_vulnerability" name="is_document_vulnerability" rules="" v-slot="{ errors }">
              <small class="label">13.2 Have you carried out a documented vulnerability risk assessment on all food raw materials to assess the potential risk of adulteration or substitution?  </small>
              <vs-switch v-model="form.is_document_vulnerability" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_document_vulnerability" vid="is_document_vulnerability_text" name="is_document_vulnerability_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_document_vulnerability_text" class="w-full" v-model="form.is_document_vulnerability_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_material_risk" name="is_material_risk" rules="" v-slot="{ errors }">
              <small class="label">13.3 Are any of the ingredients in the materials supplied to ITS at risk? </small>
              <vs-switch v-model="form.is_material_risk" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_material_risk" vid="is_material_risk_text" name="is_material_risk_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_material_risk_text" class="w-full" v-model="form.is_material_risk_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="testing_for_at_risk" name="testing_for_at_risk" rules="required" v-slot="{ errors }">
              <small class="label">13.4 What testing is carried out on those “at risk” materials to demonstrate due diligence and reduce the risk?</small>
              <vs-input type="text" name="testing_for_at_risk" class="w-full" v-model="form.testing_for_at_risk" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="summary_traceability" name="summary_traceability" rules="required" v-slot="{ errors }">
              <small class="label">13.4 Please provide summary of your traceability system back to the suppliers of the ingredients used, this can be an actual example</small>
              <vs-input type="text" name="summary_traceability" class="w-full" v-model="form.summary_traceability" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>




        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_authenticity_traceability_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_document_vulnerability:false,
          is_material_risk:false
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_authenticity_traceability_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.UpdateManufactureAuthenticityAndTraceabilityDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture Authenticity & Traceability Details Updated!')
          // this.onClickNext()
          this.$router.push({path: `/pages/manage-nimble/suppliers/${this.$route.params.supplierId}`})
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.CreateManufactureAuthenticityAndTraceabilityDetails(this.form))
          this.showSuccessMessage('Manufacture Authenticity & Traceability Created!')
          this.$router.push({path: `/pages/manage-nimble/suppliers/${this.$route.params.supplierId}`})
          // this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureAuthenticityAndTraceabilityDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_authenticity_traceability_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
